module.exports = __webpack_public_path__ + "aecaadfd59390a366ea384735259f107.png";